import React, {
    useContext,
    useMemo
} from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import CommonConstants from 'sg-common-constants';
import { SgDateUtil } from 'saga-modules';
import metadata from './SgDriverChangesSummary.metadata.json5';
import messages from './SgDriverChangesSummary.messages';

function SgDriverChangesSummary(props) {
    const {
        changes,
        getValue,
        showVehicleChanges
    } = props;

    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const isMobile = breakpoint === 'tablet' || breakpoint === 'phoneWide' || breakpoint === 'phone';
    const contactUsPhoneNumber = CommonConstants.SAGA_PHONE_NUMBERS.SAGA_CEP_VEHICLE_ALTERNATIVE_ADDRESS_PHONE_NUMBER;

    const alternativeAddressTextContent = useMemo(() => {
        return (
            <p>
                {translator(messages.AlternativeAddress, {
                    phoneNumber: isMobile
                        ? <a href={`tel:${contactUsPhoneNumber.replaceAll(' ', '')}`}>{contactUsPhoneNumber}</a>
                        : contactUsPhoneNumber
                })}
            </p>
        );
    }, [isMobile, translator, contactUsPhoneNumber]);

    const overrideProps = {
        addedDriver: {
            visible: !_.isNil(changes.addedDriver),
            content: !_.isNil(changes.addedDriver)
                ? (
                    <>
                        {translator(messages.DriverAdded,
                            {
                                driver: (
                                    <p>
                                        {`${changes.addedDriver.person.firstName} ${changes.addedDriver.person.lastName}, 
                                            DOB: ${SgDateUtil.toStringShort(changes.addedDriver.person.dateOfBirth)}`}
                                    </p>
                                )
                            })}
                    </>
                ) : null
        },
        alternativeAddressText: {
            visible: !_.isNil(changes.addedDriver),
            content: alternativeAddressTextContent
        },
        removedDriver: {
            visible: !_.isNil(changes.removedDriver),
            content: !_.isNil(changes.removedDriver)
                ? (
                    <>
                        {translator(messages.DriverRemoved,
                            {
                                driver: (
                                    <p>
                                        {`${changes.removedDriver.person.firstName} ${changes.removedDriver.person.lastName}, 
                                            DOB: ${SgDateUtil.toStringShort(changes.removedDriver.person.dateOfBirth)}`}
                                    </p>
                                )
                            })}
                    </>
                ) : null
        },
        mileage: {
            visible: showVehicleChanges && !_.isNil(changes.mileage),
            content: !_.isNil(changes.mileage)
                ? (
                    <>
                        {translator(messages.MileageChange, { mileage: <p>{getValue(changes.mileage)}</p> })}
                    </>
                ) : null
        },
        vehicleUse: {
            visible: showVehicleChanges && !_.isNil(changes.vehicleUse),
            content: !_.isNil(changes.vehicleUse)
                ? (
                    <>
                        {translator(messages.VehicleUseChange, { use: <p>{getValue(changes.vehicleUse)}</p> })}
                    </>
                ) : null
        }
    };

    const resolvers = {
        resolveCallbackMap: {},
        resolveComponentMap: {}
    };

    return renderContentFromMetadata(metadata.componentContent, overrideProps, resolvers);
}

export default SgDriverChangesSummary;
